// @mui
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// components
import Iconify from '../../../components/iconify';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// sections
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import { AppCurrentVisits } from '../../../sections/@dashboard/app';

import moment from 'moment';
import LineChartCustom from 'src/component-project/LineChartCustom';

// ---------------------------------------------------------------------

export default function ExpenseTotal({
    selectedValue = 'one',
    startDay = moment().startOf('month').format('YYYYMMDD'),
    toDay = moment().format('YYYYMMDD'),
    tableRef = null,
}) {
    const theme = useTheme();
    const [tableData, setTableData] = useState([]);
    const [getFlags, setGetFlags] = useState(false);
    const refFlags = useRef(false);

    const monthMoney = useRef({
        prev: {},
        old: {},
    });

    const { t } = useTranslation();

    const [tableData2Month, setTableData2Month] = useState([]);
    const [dateData2Month, setDateData2Month] = useState([]);
    const percent_diff_money = useRef({});
    const percent_diff_qty = useRef({});

    useEffect(() => {
        setTimeout(() => {
            getData(startDay);
        }, 600);
    }, [startDay, toDay, selectedValue]);

    const getData = useCallback(() => {
        if (refFlags.current) {
            return;
        }
        setGetFlags(true);
        refFlags.current = true;
        const InVal = [startDay, toDay];
        sendRequest(serviceList.getStatisticsDepartment_2month, InVal, getDataResult, true, timeOutFunct, 40000);
    }, [startDay, toDay, selectedValue]);

    const getDataResult = (reqInfoMap, message) => {
        setGetFlags(false);
        refFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setTableData([]);
            setTableData2Month([]);
            setDateData2Month([]);
            return;
        } else {
            if (selectedValue === 'one') {
                const data = message.proc_data.rows[0];
                setTableData(message.proc_data.rows[0].o_2);
                monthMoney.current.prev = data.o_2;
                monthMoney.current.old = data.o_3;
            } else {
                const data = message.proc_data.rows[0];
                setDateData2Month(data.o_1);
                setTableData2Month(data.o_2);
            }
            percent_diff_money.current = message.proc_data.rows[0].o_3;
            percent_diff_qty.current = message.proc_data.rows[0].o_4;
        }
    };

    const timeOutFunct = (reqInfo) => {
        setGetFlags(false);
        refFlags.current = false;
    };

    const renderHeaederSub = (type) => {
        try {
            if (type === 'money') {
                const percent_diff_prev = percent_diff_money.current.percent_diff_prev;
                const percent_diff_old = percent_diff_money.current.percent_diff_old;
                return (
                    <>
                        {percent_diff_prev < 0 ? (
                            <span>
                                {' '}
                                <strong style={{ color: 'red' }}>
                                    <Iconify icon="streamline:graph-bar-decrease-solid" /> {Math.abs(percent_diff_prev)}
                                    %
                                </strong>{' '}
                                {t('compare_last')}
                            </span>
                        ) : (
                            <span>
                                {' '}
                                <strong style={{ color: 'green' }}>
                                    <Iconify icon="streamline:graph-bar-increase-solid" /> {percent_diff_prev}%
                                </strong>{' '}
                                {t('compare_last')}
                            </span>
                        )}
                        {percent_diff_old < 0 ? (
                            <span>
                                {' '}
                                {t('and')}{' '}
                                <strong style={{ color: 'red' }}>
                                    <Iconify icon="streamline:graph-bar-decrease-solid" /> {Math.abs(percent_diff_old)}%
                                </strong>{' '}
                                {t('compare_previous')}
                            </span>
                        ) : (
                            <span>
                                {' '}
                                {t('and')}{' '}
                                <strong style={{ color: 'green' }}>
                                    <Iconify icon="streamline:graph-bar-increase-solid" /> {percent_diff_old}%
                                </strong>{' '}
                                {t('compare_previous')}
                            </span>
                        )}
                    </>
                );
            }
            if (type === 'quantity') {
                const percent_diff_prev = percent_diff_qty.current.percent_diff_prev;
                const percent_diff_old = percent_diff_qty.current.percent_diff_old;
                return (
                    <>
                        {percent_diff_prev < 0 ? (
                            <span>
                                {' '}
                                <strong style={{ color: 'red' }}>
                                    <Iconify icon="streamline:graph-bar-decrease-solid" /> {Math.abs(percent_diff_prev)}
                                    %
                                </strong>{' '}
                                {t('compare_last')}
                            </span>
                        ) : (
                            <span>
                                {' '}
                                <strong style={{ color: 'green' }}>
                                    <Iconify icon="streamline:graph-bar-increase-solid" /> {percent_diff_prev}%
                                </strong>{' '}
                                {t('compare_last')}
                            </span>
                        )}
                        {percent_diff_old < 0 ? (
                            <span>
                                {' '}
                                {t('and')}{' '}
                                <strong style={{ color: 'red' }}>
                                    <Iconify icon="streamline:graph-bar-decrease-solid" /> {Math.abs(percent_diff_old)}%
                                </strong>{' '}
                                {t('compare_previous')}
                            </span>
                        ) : (
                            <span>
                                {' '}
                                {t('and')}{' '}
                                <strong style={{ color: 'green' }}>
                                    <Iconify icon="streamline:graph-bar-increase-solid" /> {percent_diff_old}%
                                </strong>{' '}
                                {t('compare_previous')}
                            </span>
                        )}
                    </>
                );
            }
        } catch (error) {}
    };

    return (
        <>
            {selectedValue === 'one' && (
                <>
                    <Grid item xs={12} md={12} lg={6} xl={6}>
                        <AppCurrentVisits
                            title={t('report_money')}
                            subheader={tableData.length > 0 ? renderHeaederSub('money') : t('not_data_report')}
                            chartData={tableData}
                            showLegend={true}
                            totalLabel={t('total_money')}
                            label="departs_nm"
                            value="total_result_price_current"
                            chartColors={[
                                theme.palette.primary.main,
                                theme.palette.info.main,
                                theme.palette.warning.main,
                                theme.palette.error.main,
                                '#ba68c8',
                                '#FF8042',
                                '#00C49F',
                                '#FFBB28',
                                '#AF19FF',
                            ]}
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={6} xl={6}>
                        <AppCurrentVisits
                            title={t('report_qty')}
                            subheader={tableData.length > 0 ? renderHeaederSub('quantity') : t('not_data_report')}
                            chartData={tableData}
                            totalLabel={t('total_quantity')}
                            label="departs_nm"
                            showLegend={true}
                            value="total_qty_current"
                            chartColors={[
                                theme.palette.primary.main,
                                theme.palette.info.main,
                                theme.palette.warning.main,
                                theme.palette.error.main,
                                '#ba68c8',
                                '#FF8042',
                                '#00C49F',
                                '#FFBB28',
                                '#AF19FF',
                            ]}
                        />
                    </Grid>
                </>
            )}
            {selectedValue === 'two' && (
                <>
                    <Grid item xs={12} md={12} lg={6} xl={6}>
                        <LineChartCustom
                            title={t('report_money')}
                            subheader={tableData2Month.length > 0 ? renderHeaederSub('money') : t('not_data_report')}
                            label="departs_nm"
                            chartData={tableData2Month}
                            dateData={dateData2Month}
                            type="money"
                        />
                    </Grid>
                    <Grid item xs={12} md={12} lg={6} xl={6}>
                        <LineChartCustom
                            title={t('report_qty')}
                            subheader={tableData2Month.length > 0 ? renderHeaederSub('quantity') : t('not_data_report')}
                            label="departs_nm"
                            chartData={tableData2Month}
                            dateData={dateData2Month}
                            type="qty"
                        />
                    </Grid>
                </>
            )}

            <TableContainer sx={{}} style={{ display: 'none' }}>
                {selectedValue === 'one' ? (
                    <Table ref={tableRef}>
                        <TableHead>
                            <TableRow>
                                <TableCell>{t('code_department')}</TableCell>
                                <TableCell align="right">{t('name_department')}</TableCell>
                                <TableCell align="right">{t('total_money')}</TableCell>
                                <TableCell align="right">{t('total_quantity')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData.length > 0 &&
                                tableData.map((item, index) => {
                                    return (
                                        <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                            <TableCell padding="checkbox">{item.depart_cd}</TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.departs_nm}
                                            </TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.total_result_price_current}
                                            </TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.total_qty_current}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                ) : (
                    <Table ref={tableRef}>
                        <TableHead>
                            <TableRow>
                                <TableCell rowSpan={2}>{t('code_department')}</TableCell>
                                <TableCell rowSpan={2} align="right">
                                    {t('name_department')}
                                </TableCell>
                                <TableCell colSpan={3} align="right">
                                    {t('total_money')}
                                </TableCell>
                                <TableCell colSpan={3} align="right">
                                    {t('total_quantity')}
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="right">
                                    {glb_sv.convertMultipleDate(dateData2Month.start_date_old)} -{' '}
                                    {glb_sv.convertMultipleDate(dateData2Month.end_date_old)}
                                </TableCell>
                                <TableCell align="right">
                                    {glb_sv.convertMultipleDate(dateData2Month.start_date_previous)} -{' '}
                                    {glb_sv.convertMultipleDate(dateData2Month.end_date_previous)}
                                </TableCell>
                                <TableCell align="right">
                                    {glb_sv.convertMultipleDate(dateData2Month.start_date_current)} -{' '}
                                    {glb_sv.convertMultipleDate(dateData2Month.end_date_current)}
                                </TableCell>

                                <TableCell align="right">
                                    {glb_sv.convertMultipleDate(dateData2Month.start_date_old)} -{' '}
                                    {glb_sv.convertMultipleDate(dateData2Month.end_date_old)}
                                </TableCell>
                                <TableCell align="right">
                                    {glb_sv.convertMultipleDate(dateData2Month.start_date_previous)} -{' '}
                                    {glb_sv.convertMultipleDate(dateData2Month.end_date_previous)}
                                </TableCell>
                                <TableCell align="right">
                                    {glb_sv.convertMultipleDate(dateData2Month.start_date_current)} -{' '}
                                    {glb_sv.convertMultipleDate(dateData2Month.end_date_current)}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableData2Month.length > 0 &&
                                tableData2Month.map((item, index) => {
                                    return (
                                        <TableRow hover key={index} tabIndex={-1} role="checkbox">
                                            <TableCell padding="checkbox">{item.depart_cd}</TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.departs_nm}
                                            </TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.total_result_price_old}
                                            </TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.total_result_price_previous}
                                            </TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.total_result_price_current}
                                            </TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.total_qty_old}
                                            </TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.total_qty_previous}
                                            </TableCell>
                                            <TableCell align="left" width={200}>
                                                {item.total_qty_current}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                )}
            </TableContainer>
        </>
    );
}
